/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the PlayerListEntry interface.
 */
export function instanceOfPlayerListEntry(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function PlayerListEntryFromJSON(json) {
    return PlayerListEntryFromJSONTyped(json, false);
}
export function PlayerListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'locationName': !exists(json, 'locationName') ? undefined : json['locationName'],
        'active': json['active'],
        'referenceId': !exists(json, 'referenceId') ? undefined : json['referenceId'],
        'provider': !exists(json, 'provider') ? undefined : json['provider']
    };
}
export function PlayerListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'locationId': value.locationId,
        'networkId': value.networkId,
        'locationName': value.locationName,
        'active': value.active,
        'referenceId': value.referenceId,
        'provider': value.provider
    };
}
